import moduleName from 'store/listApi/constants';
import { get } from 'lodash';

export const getListApiParams = (state, key) => get(state, [moduleName, key]);
